import { AuthProvider } from '@sdk/authentication/AuthContext';
import ToastComponent from '@sdk/common/toast/ToastComponent';

import { UserSettingsProvider } from '@web/settings/UserSettingsContext';
import { UserOrgSettingsProvider } from '@web/settings/UserOrgSettingsContext';
import ClockOutModal from '@web/timeClock/ClockOutModal/ClockOutModal';

const ClockOutModalAngular = ({
  shift,
  onCommentSave,
  clockOut,
  onTaskPreview,
  isTaskModalVisible = false,
  Authentication,
}) => (
  <AuthProvider currentUser={Authentication.user}>
    <UserSettingsProvider settings={Authentication.user.settings}>
      <UserOrgSettingsProvider settings={Authentication.user.orgSettings}>
        <ClockOutModal
          shift={shift}
          onCommentSave={onCommentSave}
          clockOut={clockOut}
          onTaskPreview={onTaskPreview}
          isTaskModalVisible={isTaskModalVisible}
        />
        <ToastComponent />
      </UserOrgSettingsProvider>
    </UserSettingsProvider>
  </AuthProvider>
);

export default {
  ReactComponent: ClockOutModalAngular,
  dependencies: ['Authentication'],
  bindings: {
    shift: '<',
    onCommentSave: '&',
    clockOut: '&',
    onTaskPreview: '&',
    isTaskModalVisible: '<',
  },
};
